import {
  chartOverlaysBorder,
  chartOverlaysBorder__rightAxis,
  chartOverlaysBorder__topAxis,
  chartOverlaysBorder__xAxis,
  chartOverlaysBorder__yAxis,
} from './ChartOverlaysBorder.sty.js';

interface ChartOverlaysBorderProps {
  left?: boolean;
  right?: boolean;
  bottom?: boolean;
  top?: boolean;
}

/* A function to conditionally render the borders based on the component props
 * @params { boolean } left - A boolean to display the x-axis border. Default is
 * false
 * @params { boolean } right - A boolean to display the right axis. Default is false
 * @params { boolean } bottom - A boolean to display the y-axis. Default is
 * false
 * @returns { string } An interpolated string with the necerrary borders
 * classNames.
 */
const chartOverlaysBorderStyle = (
  left: boolean = false,
  right: boolean = false,
  bottom: boolean = false,
  top: boolean = false,
): string => {
  return `
    ${chartOverlaysBorder}
    ${left ? chartOverlaysBorder__xAxis : ''}
    ${right ? chartOverlaysBorder__rightAxis : ''}
    ${bottom ? chartOverlaysBorder__yAxis : ''}
    ${top ? chartOverlaysBorder__topAxis : ''}
  `;
};

/**
 * A component to render a mimic axis borders conditionally
 **/
export const ChartOverlaysBorder = ({
  left,
  right,
  bottom,
  top,
}: ChartOverlaysBorderProps) => {
  const style = chartOverlaysBorderStyle(left, right, bottom, top);
  return <div className={style} />;
};
